import React, { useEffect, useState } from "react";
import "./SettingsComponent.css";
import { useDispatch } from "react-redux";
import Switch from "@mui/material/Switch";
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
} from "@mui/material";
import { postSingleSignOn, resetExceptionError } from "../store/actions";
import Alert from "./Alert";

const SettingsCard = ({
  Icon,
  title,
  desc,
  company,
  isToggleEnabled,
  clientId,
}) => {
  const [isEnabled, setIsEnabled] = useState(false);
  const [openPopup, setOpenPopup] = useState(false);
  const [clientSecret, setClientSecret] = useState("");
  const [popupKey, setPopupKey] = useState("");
  const [mandatoryError, setMandatoryError] = useState(false);
  const dispatch = useDispatch();
  useEffect(() => {
    if (isToggleEnabled) {
      setIsEnabled(isToggleEnabled);
    }
  }, [isToggleEnabled]);
  useEffect(() => {
    if (clientId !== "") {
      setClientSecret(clientId);
    }
  }, [clientId]);
  const handleToggle = (event, popup_key) => {
    setPopupKey(popup_key);
    if (popup_key === "google") {
      if (clientSecret){
        setIsEnabled(event.target.checked);
        dispatch(
          postSingleSignOn(clientSecret, popup_key, event.target.checked, false));
        } else {
          setMandatoryError(true)
        }
    } else if (popup_key === "microsoft") {
      if (clientSecret){
        setIsEnabled(event.target.checked);
        dispatch(
          postSingleSignOn(clientSecret, popup_key, false, event.target.checked));
        } else {
          setMandatoryError(true)
        }
    }
  };

  const handleOpenPopup = (popup_key) => {
    setOpenPopup(true);
    setPopupKey(popup_key);
  };

  const handleClosePopup = () => {
    setOpenPopup(false);
  };

  const handleSave = (e) => {
    e.preventDefault();
    if (popupKey === "google") {
      dispatch(postSingleSignOn(clientSecret, popupKey, isEnabled, false));
    } else if (popupKey === "microsoft") {
      dispatch(postSingleSignOn(clientSecret, popupKey, false, isEnabled));
    }
    setOpenPopup(false);
  };

  return (
    <>
      {mandatoryError &&
          Alert.warning({
            title: "Mandatory Field Required",
            text: "Create Client Id and then turn on SSO",
            icon: "warning",
            preConfirm: (isConfirm) => {
              if (isConfirm) {
                dispatch(resetExceptionError());
                setMandatoryError(false)
              } else {
              }
            },
          })}
      <div className="settings-container">
        <div className="settings-icon">
          <img src={Icon} alt="icon" />
        </div>

        <div className="settings-name">{title}</div>
        <div className="settings-description">{desc}</div>

        <div className="settings-enalbe-container">
          <div>
            <Button onClick={() => handleOpenPopup(company)}>Manage</Button>
          </div>

          <div className="settings-enabled-toggle">
            <Switch
              checked={isEnabled}
              onChange={(event) => handleToggle(event, company)}
            />
          </div>
        </div>
      </div>

      {/* Popup Modal */}
      <Dialog open={openPopup} onClose={handleClosePopup}>
        <DialogTitle>Add Client Id</DialogTitle>
        <DialogContent>
          <form onSubmit={(e) => handleSave(e)} id="save-form">
            <TextField
              autoFocus
              required
              margin="dense"
              id="clientscript"
              type="password"
              InputProps={{
                sx: {
                  "& input": {
                    border: "none !important",
                    outline: "none !important",
                  },
                },
              }}
              sx={{ width: "350px" }}
              name="client_script"
              label="Client Id"
              fullWidth
              variant="outlined"
              value={clientSecret}
              onChange={(e) => setClientSecret(e.target.value)}
            />
          </form>
        </DialogContent>
        <DialogActions>
          <div style={{ display: "flex", gap: "12px" }}>
            <Button onClick={handleClosePopup}>Cancel</Button>
            <Button type="submit" form="save-form" variant="contained">
              Save
            </Button>
          </div>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default SettingsCard;
